import React from 'react';
import { useTranslation } from 'react-i18next';
import PageTitle from '../components/PageTitle';
import HoursBlock from '../components/HoursBlock';

/**
 * Page for the hours.
 * @return {jsx} The component.
 */
function Heures() {
  const { t } = useTranslation();

  return (
    <div className='w-full lg:w-3/4 mx-auto px-4 flex flex-col justify-center items-center'>
      <PageTitle title={t('hours')} subtext={t('hoursMessage')} />
      <p></p>
      <div className='grid grid-cols-1 sm:grid-cols-2 gap-3 justify-center w-full lg:w-3/4'>
        <HoursBlock name={'Lacolle'} dutyFreeId={221} />
        <HoursBlock name={'Richelieu'} dutyFreeId={223} />
      </div>
    </div>
  );
}

export default Heures;
